import _ from 'lodash'

type EventHandler = (event: Event) => void

export class EventHandlersPool<T extends EventTarget> {
  private _eventTarget: T;
  private _eventName: string;
  private _eventHandlers = new Map<string, EventHandler>()

	public constructor(eventTarget: T, eventName: string) {
    this._eventTarget = eventTarget;
		this._eventName = eventName;
	}

  public has(key: string) {
    return this._eventHandlers.has(key)
  }

  public remove(key: string) {
    const eventHandler = this._eventHandlers.get(key)
    if (eventHandler) {
      this._eventTarget.removeEventListener(this._eventName, eventHandler)
      this._eventHandlers.delete(key)
    }
  }

  public add(eventHandler: EventHandler): string {
    const key = _.uniqueId('EventHandlersPool')
    this._eventHandlers.set(key, eventHandler)
    this._eventTarget.addEventListener(this._eventName, eventHandler)
    return key
  }

  /*
  *  Отпишется от события после первого вызова
  */
  public addWithAutoRemoving(eventHandler: EventHandler): string {
    const key = _.uniqueId('EventHandlersPool')
    const eventHandlerWithAutoRemoving = (event: Event) => {
      eventHandler(event)
      this.remove(key)
    }
    this._eventHandlers.set(key, eventHandlerWithAutoRemoving)
    this._eventTarget.addEventListener(this._eventName, eventHandlerWithAutoRemoving)
    return key
  }
}
